<app-payments-info-dialog
  class="bank-transfer-info-dialog"
  [dialogType]="dialogType"
  [headerLabel]="'DIALOG.PAYMENTS.HEADER.BANK_TRANSFER' | translate"
  [introLabel]="'DIALOG.PAYMENTS.INTRO.BANK_TRANSFER' | translate"
  [description]="description"
  [confirmLabel]="'ACTION.LEARN_MORE' | translate"
  [confirmUrl]="confirmUrl"
  [listItems]="listItems"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  (onConfirm)="onConfirm.emit()"
  (onCancel)="onCancel.emit()"
>
</app-payments-info-dialog>
